import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button'
import { DocumentCard, DocumentCardTitle
    //  , DocumentCardPreview  
    } from 'office-ui-fabric-react/lib/DocumentCard'

import Report from './Report'
import {objectValues} from '../utils/format-report-jfc'

export default class MainPage extends Component {
  constructor(props) {
    super(props)
    this.props = props

    this.handleKeyPress = this.handleKeyPress.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
    this.renderCp = this.renderCp.bind(this)
    this.parseData = this.parseData.bind(this)

    this.state = {selected: 0, message: ''} 

  }

  componentDidMount() {
    const { fetchActivities, assessmentId } = this.props
    fetchActivities(assessmentId)
  }

  componentDidUpdate(prevProps) {
    
    if (this.props.assessmentId !== prevProps.assessmentId) {
      const { fetchActivities, assessmentId } = this.props
      fetchActivities(assessmentId)
    }
  }

    handleFocus(ev) {
        this.setState({selected: ev.target.tabIndex})
    }
handleKeyPress(ev) {

    const {inputs, values} = this.props
    let selected = this.state.selected
    if (ev.key >= 1 && ev.key <= 5) { 
        values[selected] = ev.key
    }
    switch(ev.key) {
        case 'ArrowUp':
            selected--
            if (selected < 0) selected = 0
            break
        case 'ArrowDown':
            selected++
            //if (selected > inputs.length - 1) selected = inputs.length - 1
            if (selected > inputs.length - 1) selected = inputs.length - 1
            break
        default:
            break
    }

    if (ev.key == 'ArrowUp' || ev.key == 'ArrowDown') {
        inputs[selected].focus()
    }
    this.setState({selected, values})
    
}

renderCp(cp, i) {
    const levels = ['', '1. Individual Contributors', '2. Officers','3. Managers','4. Sr.Managers','5. Executives' ]
    return <div className="ms-Grid" >
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-lg2 ms-font-xl">{cp.name} {cp.sort}</div>
                <div className="ms-Grid-col ms-lg10">{cp.description}</div>
            </div>
            <div className="ms-Grid-row">
            { levels.map( (level,i) => <div key={i} className="ms-Grid-col ms-lg2">{level}</div>) }
            </div>
            {Object.values(cp.dimensions).map(this.renderDim)}

        </div>
}

parseData(e) {
  let data = e.clipboardData.getData('text/plain')
  let lines = data.split('\r\n')      
  let cps = []
  for (let i=0; i < lines.length; i++) {
    let cp = lines[i].split('\t')
    cps.push(cp)
  }
  this.setState({mmm: cps})

}

  render() {
    const { competencies } = this.props
    this.index = 0
    window.document.addEventListener('paste', this.parseData)
    return (
      <div>
        {/*objectValues(competencies).map(cp => 
          <div>{cp.name}<ul>{objectValues(cp.answers).map(answer => <li>{answer}</li>)}</ul></div>
        )*/}
        <Report data={competencies} />
        
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/modules/competencies/components/MainPage.js